export default __webpack_public_path__ + "static/projectFour-43bbc32ae021ee5992b7dfd8ae2036dd.jpg";